export const pad = [
  {
    value: '0',
    start: 0,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#19492E',
  },
  {
    value: '3',
    start: 3,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#1D2738',
  },
  {
    value: '6',
    start: 6,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#D9113A',
  },
  {
    value: '9',
    start: 9,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#1D2738',
  },
  {
    value: '12',
    start: 12,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#1D2738',
  },
  {
    value: '15',
    start: 15,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#D9113A',
  },
  {
    value: '18',
    start: 18,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#1D2738',
  },
  {
    value: '21',
    start: 21,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#1D2738',
  },
  {
    value: '24',
    start: 24,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#D9113A',
  },
  {
    value: '27',
    start: 27,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#1D2738',
  },
  {
    value: '30',
    start: 30,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#1D2738',
  },
  {
    value: '33',
    start: 33,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#D9113A',
  },
  {
    value: '36',
    start: 36,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#1D2738',
  },
  {
    value: '2',
    start: 2,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#D9113A',
  },
  {
    value: '5',
    start: 5,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#1D2738',
  },
  {
    value: '8',
    start: 8,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#D9113A',
  },
  {
    value: '11',
    start: 11,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#D9113A',
  },
  {
    value: '14',
    start: 14,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#1D2738',
  },
  {
    value: '17',
    start: 17,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#D9113A',
  },
  {
    value: '20',
    start: 20,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#D9113A',
  },
  {
    value: '23',
    start: 23,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#1D2738',
  },
  {
    value: '26',
    start: 26,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#D9113A',
  },
  {
    value: '29',
    start: 29,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#D9113A',
  },
  {
    value: '32',
    start: 32,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#1D2738',
  },
  {
    value: '35',
    start: 35,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#D9113A',
  },
  {
    value: '1',
    start: 1,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#1D2738',
  },
  {
    value: '4',
    start: 4,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#D9113A',
  },
  {
    value: '7',
    start: 7,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#1D2738',
  },
  {
    value: '10',
    start: 10,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#D9113A',
  },
  {
    value: '13',
    start: 13,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#D9113A',
  },
  {
    value: '16',
    start: 16,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#1D2738',
  },
  {
    value: '19',
    start: 19,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#1D2738',
  },
  {
    value: '22',
    start: 22,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#D9113A',
  },
  {
    value: '25',
    start: 25,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#1D2738',
  },
  {
    value: '28',
    start: 28,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#D9113A',
  },
  {
    value: '31',
    start: 31,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#D9113A',
  },
  {
    value: '34',
    start: 34,
    count: 1,
    diff: 0,
    hover: false,
    active: false,
    color: '#1D2738',
  },
  {
    value: '2:1',
    start: 3,
    count: 12,
    diff: 3,
    hover: false,
    active: false,
    color: '#ffffff14',
    round: '0 16px 0 0',
  },
  {
    value: '2:1',
    start: 2,
    count: 12,
    diff: 3,
    hover: false,
    active: false,
    color: '#ffffff14',
  },
  {
    value: '2:1',
    start: 1,
    count: 12,
    diff: 3,
    hover: false,
    active: false,
    color: '#ffffff14',
    round: '0px 0px 16px 0px'
  },
  {
    value: '1 to 12',
    start: 1,
    count: 12,
    diff: 1,
    hover: false,
    active: false,
    color: '#ffffff14',
  },
  {
    value: '13 to 24',
    start: 13,
    count: 12,
    diff: 1,
    hover: false,
    active: false,
    color: '#ffffff14',
  },
  {
    value: '25 to 36',
    start: 25,
    count: 12,
    diff: 1,
    hover: false,
    active: false,
    color: '#ffffff14',
  },
  {
    value: '1 to 18',
    start: 1,
    count: 18,
    diff: 1,
    hover: false,
    active: false,
    color: '#ffffff14',
    round: '0px 0px 0px 16px'
  },
  {
    value: 'Even',
    start: 2,
    count: 18,
    diff: 2,
    hover: false,
    active: false,
    color: '#ffffff14',
  },
  {
    value: '',
    start: -1,
    count: 0,
    diff: 0,
    hover: false,
    active: false,
    color: '#1D2738',
  },
  {
    value: '',
    start: -2,
    count: 0,
    diff: 0,
    hover: false,
    active: false,
    color: '#D9113A',
  },
  {
    value: 'Odd',
    start: 1,
    count: 18,
    diff: 2,
    hover: false,
    active: false,
    color: '#ffffff14',
  },
  {
    value: '19 to 36',
    start: 19,
    count: 18,
    diff: 1,
    hover: false,
    active: false,
    color: '#ffffff14',
    round: '0px 0px 16px 0px'
  },
]
